class ProductOption extends HTMLElement {
  abortController;

  /**
   * Connected callback.
   */
  connectedCallback() {
    this.querySelector('input').addEventListener('change', () => this.changeHandler());
  }

  /**
   * Disconnected callback.
   */
  disconnectedCallback() {
    this.querySelector('input').removeEventListener('change', this.changeHandler);
  }

  /**
   * Change handler, show/hide the option description.
   * @param {Event} event - The change event.
   */
  changeHandler = () => {
    const value = this.querySelector('input').value;
    const checked = this.querySelector('input').checked;

    this.closest('fieldset')
      ?.querySelectorAll('[data-option-description]')
      .forEach((optionDescription) => {
        const optionDescriptionValue = optionDescription.dataset.optionDescription;
        if (optionDescriptionValue === value) {
          optionDescription.classList.toggle('hidden', !checked);
        } else {
          optionDescription.classList.add('hidden');
        }
      });
  };
}

customElements.define('product-option', ProductOption);
